import moment from 'moment';
const convToTime = (date: string) => {
  if (date) {
    return moment(date).format('hh:mm A');
  }
  return '';
};
export default convToTime;
